// extracted by mini-css-extract-plugin
export default {"page":"FormSigner_page__bfMV3","content":"FormSigner_content__fDgGb","section":"FormSigner_section__Moo53"};